export default "__VITE_ASSET__C9UIUoqg__"